// Angular
import { Component, ChangeDetectorRef } from '@angular/core';
import { LayoutConfigService } from '../../../../core/_base/layout';
import { AuthServiceCustom } from 'src/app/core/auth/authServiceCustom';

@Component({
    selector: 'kt-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent {
    searchDisplay = true;
    notificationsDisplay = true;
    quickActionsDisplay = true;
    cartDisplay = true;
    quickPanelDisplay = true;
    userDisplay = false;
    userLayout = 'offcanvas';
    userDropdownStyle = 'light';
    openUser = false;

    constructor(
        private layoutConfigService: LayoutConfigService,
        private authServiceCustom: AuthServiceCustom,
        private cdRef: ChangeDetectorRef,
    ) {
        this.searchDisplay = this.layoutConfigService.getConfig('extras.search.display');
        this.notificationsDisplay = this.layoutConfigService.getConfig('extras.notifications.display');
        this.quickActionsDisplay = this.layoutConfigService.getConfig('extras.quick-actions.display');
        this.cartDisplay = this.layoutConfigService.getConfig('extras.cart.display');
        this.quickPanelDisplay = this.layoutConfigService.getConfig('extras.quick-panel.display');
        // this.userDisplay = this.layoutConfigService.getConfig('extras.user.display');
        this.userLayout = this.layoutConfigService.getConfig('extras.user.layout');
        this.userDropdownStyle = this.layoutConfigService.getConfig('extras.user.dropdown.style');
    }

    userName: string = '';
    givenName: string = '';
    imgUser: string = '';
    email: string = '';

    ngOnInit(): void {
        this.stateUser();
    }

    stateUser() {
        let token = sessionStorage.getItem('access_token');

        if (token != null) {
            setTimeout(() => {
                this.oauthInformation();
                this.cdRef.detectChanges();
            }, 1);

            this.openUser = true;
            this.userDisplay = true;
        }
    }

    private oauthInformation(): void {
        this.userName = this.authServiceCustom.userName;
        this.givenName = this.authServiceCustom.givenName;
    }
}
